/**
 * Retorna a etapa de comunicação apropriada com base no número de dias fornecido.
 *
 * @param {number} days - O número de dias para determinar a etapa de comunicação.
 * @returns {string} A etapa de comunicação correspondente aos dias fornecidos.
 *
 * @example
 * // Retorna 'WhatsApp' para dias entre 1 e 29
 * const step = getCommunicationStep(15);
 *
 * @example
 * // Retorna 'Ligação' para dias entre 30 e 44
 * const step = getCommunicationStep(35);
 *
 * @example
 * // Retorna 'Serasa' para dias entre 45 e 59
 * const step = getCommunicationStep(50);
 *
 * @example
 * // Retorna 'Acordo' para dias entre 60 e 74
 * const step = getCommunicationStep(65);
 *
 * @example
 * // Retorna 'Protesto' para dias 75 ou mais
 * const step = getCommunicationStep(80);
 */
export function getCommunicationStep(days) {
  if (days >= 1 && days <= 29) {
    return 'WhatsApp';
  } else if (days >= 30 && days <= 44) {
    return 'Ligação';
  } else if (days >= 45 && days <= 59) {
    return 'Serasa';
  } else if (days >= 60 && days <= 74) {
    return 'Acordo';
  } else {
    return 'Protesto';
  }
}
